import { motion } from "framer-motion";
import styles from "../styles/ProjectCard.module.css";
import { Project } from "../types";

export const ProjectCard = ({ project }: { project: Project }) => (
  <motion.div
    className={styles.card}
    whileHover={{ y: -10 }}
    transition={{ duration: 0.3 }}
  >
    <div className={styles.imageContainer}>
      <img
        src={project.coverImageUrl}
        alt={project.title}
        className={styles.image}
      />
    </div>
    <div className={styles.info}>
      <h3 className={styles.title}>{project.title}</h3>
      <p className={styles.description}>{project.description}</p>
      <p className={styles.meta}>
        {project.year} • {project.tags.join(" / ")}
      </p>
    </div>
  </motion.div>
);
